import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader, Panel } from "../components/Surface";
import { Button } from "../components/ui/Button";
import { StatusLabel } from "../components/ListTable";
import { labelize } from "../lib/format";
import { myListings, setListingStatus, priceUsd, type Listing } from "../lib/marketplace";

export function MyListings() {
  const [listings, setListings] = useState<Listing[]>([]);
  const [busy, setBusy] = useState<string | null>(null);

  async function refresh() {
    setListings((await myListings()).listings);
  }
  useEffect(() => { void refresh(); }, []);

  async function act(id: string, status: "sold" | "removed") {
    setBusy(id + status);
    try {
      await setListingStatus(id, status);
      await refresh();
    } finally {
      setBusy(null);
    }
  }

  return (
    <div className="mx-auto grid w-full max-w-2xl gap-6">
      <PageHeader title="My listings" subtitle="Manage what you're selling." actions={<Link to="/marketplace"><Button variant="ghost">Marketplace</Button></Link>} />
      {listings.length === 0 ? (
        <p className="text-sm text-muted">You have no listings. <Link to="/marketplace" className="font-bold text-accent-strong">Sell something →</Link></p>
      ) : (
        <div className="grid gap-2">
          {listings.map((l) => (
            <Panel key={l.id}>
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="min-w-0">
                  <Link to={`/marketplace/${l.id}`} className="font-bold hover:text-accent-strong">{l.title}</Link>
                  <p className="font-mono text-[11px] text-muted">{labelize(l.category)} · {priceUsd(l.price_cents)}</p>
                </div>
                <div className="flex items-center gap-2">
                  <StatusLabel status={l.status ?? "active"} />
                  {l.status === "active" && (
                    <>
                      <Button variant="ghost" disabled={busy === l.id + "sold"} onClick={() => act(l.id, "sold")}>Mark sold</Button>
                      <Button variant="ghost" disabled={busy === l.id + "removed"} onClick={() => act(l.id, "removed")}><span className="text-danger">Remove</span></Button>
                    </>
                  )}
                </div>
              </div>
            </Panel>
          ))}
        </div>
      )}
    </div>
  );
}
